import React from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { toggleCommission } from '../../../actions/associatesActions';
import ChevronIcon from '../../icons/chevronIcon';

const Header = ({
  title,
  showBack = true,
  showClose = false,
  onClose,
  pathName,
  pathSearch,
  pathState,
  hasBackground = false,
  onClick = null,
  rightIcon,
  rightText,
  onClickRight,
  absolute = false,
  zIndex,
  color = '#fff',
}) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const handleGoBack = () => {
    if (pathName) {
      history.push({
        pathname: pathName,
        search: pathSearch,
        state: pathState,
      });
    } else if (onClick) {
      onClick();
    } else {
      history.goBack();
    }
  };

  const handleClose = () => {
    onClose();
  };

  const handleClick = () => {
    dispatch(toggleCommission());
  };

  return (
    <div
      className={`header app w-100 ${hasBackground ? 'transition-header' : ''} ${
        absolute ? 'position-absolute' : ''
      }`}
      style={{ zIndex: zIndex }}
    >
      <div className='container'>
        <div className='row justify-content-center'>
          <div className='col-12 col-md-7 col-lg-6'>
            <div className='row'>
              {showBack ? (
                <div className='col-auto back p-0'>
                  <button
                    type='button'
                    onClick={handleGoBack}
                    className='back-button font-medium'
                    aria-label='Close'
                  >
                    <ChevronIcon fillColor={color} size={'22px'} rotation={180} />
                  </button>
                </div>
              ) : (
                <div className='col-auto p-0 back' style={{ minWidth: '55px' }}></div>
              )}

              <div
                className={`col header-title bold center ${!showBack ? ' mt-3' : ' p-0 my-auto'}`}
                style={{ marginLeft: rightIcon ? '0px' : '' }}
              >
                {title}
              </div>

              {showClose && (
                <div className='col-auto pl-0 text-right'>
                  <div className='close-page' onClick={handleClose}>
                    <div className='mdiv'>
                      <div className='md' />
                    </div>
                  </div>
                </div>
              )}

              {rightIcon && (
                <div className='col-auto my-auto' onClick={onClickRight}>
                  {rightIcon}
                </div>
              )}
              {rightText && (
                <div
                  style={{ color: 'var(--color-lighter-gray)' }}
                  onClick={onClickRight}
                  className='col-auto my-auto font-norma'
                >
                  {rightText}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
